import { useOrganizers } from '@/hooks/useOrganizers';
import { useOrganizersActions } from './useOrganizersActions';
import OrganizersManagerView from './organizersmanager.view';

const OrganizersManager = () => {
  const { data: organizersList = [], isLoading: loading } = useOrganizers();
  const actions = useOrganizersActions();

  return (
    <OrganizersManagerView
      organizersList={organizersList}
      loading={loading}
      isDialogOpen={actions.isDialogOpen}
      setIsDialogOpen={actions.setIsDialogOpen}
      editingOrganizer={actions.editingOrganizer}
      setEditingOrganizer={actions.setEditingOrganizer}
      formData={actions.formData}
      setFormData={actions.setFormData}
      handleEdit={actions.handleEdit}
      handleDelete={actions.handleDelete}
      handleSubmit={actions.handleSubmit}
      deleteTarget={actions.deleteTarget}
      setDeleteTarget={actions.setDeleteTarget}
      confirmDelete={actions.confirmDelete}
    />
  );
};

export default OrganizersManager;
